import React from 'react';
import PropTypes from 'prop-types';
import {Stack} from "@mui/material";

import ListingProductImage from "components/Product/Table/ListingProductImage";

import {Cell, Row} from "./EnrichmentTable";
import ProductCell from "./ProductCell";
import VariantChips from "./VariantChips";

ImageGroupRow.propTypes = {
    group: PropTypes.object.isRequired,
};

function ImageGroupRow({group}) {
    const variations = group.variations ?? [];
    const pictures = group.pictures ?? [];

    return (
        <Row>
            <Cell column="product">
                <ProductCell
                    name={variations[0]?.name}
                    brandName={'string' === typeof group.brand ? group.brand : null}
                    reference={variations[0]?.sku}
                    pictureUrl={pictures[0]?.url ?? null}
                />
            </Cell>
            <Cell column="variants">
                <VariantChips labels={variations.map((variation) => variation.optionsName || variation.sku)}/>
            </Cell>
            <Cell column="pictures">
                <Stack direction="row" gap="8px" sx={{overflowX: 'auto'}}>
                    {pictures.slice(1).map((picture) => (
                        <ListingProductImage key={picture.id} src={picture.url}/>
                    ))}
                </Stack>
            </Cell>
        </Row>
    );
}

export default ImageGroupRow;
